import BillLading from '@/components/BillLading/BillLading';
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import jwt_decode from 'jwt-decode'

export default {
    name: "PlatformPrintResetAudit",
    conditionData: '',
    mounted: function () {
        this.init();
    },
    components: {
        BillLading,
        pdf
    },
    data() {
        return {
            showBillLading: false,
            showPdf: true,
            billLadingData: {},
            pdfSrc: '',
            numPages: 0,
            progress: 0,
            progressShow: true,
            opinion: ''
        }
    },
    methods: {
        init() {
            // 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
            this.conditionData = this.$routerUtil.getParam();
            // this.billLadingData.shipper = this.conditionData.row.table_blCode;
            this.data = this.conditionData.row;
            console.log(this.data);
            if (this.data.blBillSignatureFiles) {
                this.data.blBillSignatureFiles.forEach(file => {
                    if (file.type === 1) {
                        this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
                    }
                });
            }
            this.pdfSrc.onProgress = progress => {
                let tempProgress = progress.loaded / progress.total * 100;
                if(tempProgress > 100){
                    tempProgress = 100;
                }
                this.progress = tempProgress;
                if (this.progress === 100) {
                    setTimeout(() => {
                        this.progressShow = false;
                        for(const key in require.cache) {
                            if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
                                console.log(key);
                                delete require.cache[key];
                            }
                        }
                    }, 500);
                }
            };
            this.loadPdfHandler();
        },
        doBack() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.push('print-reset-manage');
        },
        doConfirm(result) {
            const param = {};
            param.id = this.data.id;
            param.version = this.data.version;
            param.auditResult = result;
            param.auditOpinion = this.opinion;
            const token = jwt_decode(sessionStorage.getItem('token'));
            param.auditUserAccount = token.userAccount;
            param.auditUserName = token.userName;
            param.auditUserDay = this.getNowFormatDate();
            // 追加打印申请id参数
            param.printApplyId = this.data.printApplyId;
            this.$axios.put('/api/prints/applyResetVerify', param).then(response => {
                if (response.data.status === '1') {
                    this.doBack();
                }else{
                    this.$message({
                        message: this.$t(response.data.message),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        loadPdfHandler() {
            this.pdfSrc.promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        getNowFormatDate() {
            const date = new Date();
            const seperator1 = "-";
            const seperator2 = ":";
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            return date.getFullYear() + seperator1 + month + seperator1 + strDate
                + " " + date.getHours() + seperator2 + date.getMinutes()
                + seperator2 + date.getSeconds();
        }
    }
}
